import { useContext } from 'react';
import { useFilterFamilyOptions } from '../../hooks/useFilterFamilyOptions';
import { useFilterFamilySelect } from '../../hooks/useFilterFamilySelect';
import EditorOptionsGroupHeading from './EditorOptionsGroupHeading';
import EditorCategoryOption from './EditorCategoryOption';
import EditorNoResultsMessage from './EditorNoResultsMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import EditorScrollingBodyContainer from './EditorScrollingBodyContainer';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterFamilyOptions = props => {
  const {
    hideIcon,
    searchString
  } = props;
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    filterFamilyOptions: options
  } = useFilterFamilyOptions(searchString);
  const {
    disabledFilterFamilies,
    onFilterFamilySelect
  } = useFilterFamilySelect();
  const hasNoOptions = options.length === 0;
  return /*#__PURE__*/_jsxs(EditorScrollingBodyContainer, {
    children: [hasNoOptions && /*#__PURE__*/_jsx(View, {
      padding: "400",
      margin: "auto",
      as: "div",
      children: /*#__PURE__*/_jsx(EditorNoResultsMessage, {
        message: "newCustomerDataFilters.fieldSelectFlow.noCategoriesFoundMessage"
      })
    }), !hasNoOptions && options.map((optionsGroup, index) => {
      return /*#__PURE__*/_jsxs(View, {
        marginBlockStart: index > 0 ? '500' : '0',
        children: [/*#__PURE__*/_jsx(EditorOptionsGroupHeading, {
          children: /*#__PURE__*/_jsx(TruncateString, {
            useFlex: true,
            children: optionsGroup.text
          })
        }), optionsGroup.options.map((option, childIndex) => /*#__PURE__*/_jsx(EditorCategoryOption, {
          categoryLabel: option.text,
          dataSeleniumInfo: baseFilterFamily === option.value && !option.isAssociation ? `${option.value}__SELF` : option.value,
          dataSeleniumTest: "fr-filter-family-option",
          disabled: disabledFilterFamilies[option.value],
          hideIcon: hideIcon,
          onClick: () => {
            void (async () => {
              try {
                await onFilterFamilySelect(option);
              } catch (e) {
                console.error('Error selecting filter family option in Editor:', e);
              }
            })();
          }
        }, `${childIndex}-${option.text}`))]
      }, `${index}-${optionsGroup.text}`);
    })]
  });
};
export default EditorFilterFamilyOptions;